/* ============================================================================
   OMADA · Quality & Innovation — shared behaviour
   Reveal-on-scroll, tab panels (stepper / protocols / materials) and animated
   counters. Idempotent: safe to include from multiple sections. No theme deps.
   ========================================================================== */
(function () {
  if (window.__omadaQuality) { window.__omadaQuality.scan(); return; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal ---- */
  var revealIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('q-in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;

  function armReveals(root) {
    root.querySelectorAll('.q-rv:not(.q-armed)').forEach(function (el) {
      el.classList.add('q-armed');
      if (revealIO) { revealIO.observe(el); } else { el.classList.add('q-in'); }
    });
  }

  /* ---- tab panels (generic role=tablist) ---- */
  function wireTablist(list) {
    if (list.__wired) return; list.__wired = true;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(i) {
      tabs.forEach(function (tb, idx) {
        var on = idx === i;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(tb.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; }
      });
    }
    tabs.forEach(function (tb, i) {
      tb.addEventListener('click', function () { select(i); });
      tb.addEventListener('keydown', function (ev) {
        var d = (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') ? 1
              : (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') ? -1 : 0;
        if (d) { ev.preventDefault(); var n = (i + d + tabs.length) % tabs.length; tabs[n].focus(); select(n); }
      });
    });
  }

  /* ---- counters ---- */
  function fmt(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + 'M';
    if (n >= 1000) return (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1) + 'k';
    return String(n);
  }
  function runCounters(box) {
    if (box.__ran) return; box.__ran = true;
    box.querySelectorAll('[data-q-count]').forEach(function (el) {
      var target = +el.getAttribute('data-q-count');
      if (reduce) { el.textContent = fmt(target); return; }
      var start = null, dur = 1500;
      function tick(ts) {
        if (!start) start = ts;
        var t = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - t, 3);
        el.textContent = fmt(Math.round(target * e));
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }
  var counterIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { runCounters(e.target); counterIO.unobserve(e.target); } });
      }, { threshold: 0.4 })
    : null;

  function scan(root) {
    root = root || document;
    armReveals(root);
    root.querySelectorAll('[role="tablist"].q-tabs').forEach(wireTablist);
    root.querySelectorAll('.q-counters').forEach(function (box) {
      if (counterIO) { counterIO.observe(box); } else { runCounters(box); }
    });
  }

  window.__omadaQuality = { scan: function (r) { scan(r); } };

  if (document.readyState !== 'loading') { scan(); }
  else { document.addEventListener('DOMContentLoaded', function () { scan(); }); }

  /* Theme editor: re-scan when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:select', function (e) { scan(e.target); });
})();
